import { TChatOnboardingType } from '../types';

const ONBOARDING_COOKIE_NAME_MAP: Record<TChatOnboardingType, string> = {
  builder: 'newbuilding-card-desktop-fichering-frontend.builder_chat_onboarding_shown',
};

const CONFIG_MAP: Record<TChatOnboardingType, string> = {
  builder: 'Newbuilding.CianChatOnboarding.Enabled',
};

const CHAT_ONBOARDING_TEXT: Record<TChatOnboardingType, string> = {
  builder: 'Newbuilding.CianChatOnboarding.Text',
};

export { ONBOARDING_COOKIE_NAME_MAP, CONFIG_MAP, CHAT_ONBOARDING_TEXT };
